import { GridColDef } from "@mui/x-data-grid";
import { roleNameByKey } from "../../constants/roles-mapping";

export const columns: GridColDef[] = [
  {
    field: "name",
    headerName: "Name",
    flex: 1,
  },
  {
    field: "role",
    headerName: "Rolle",
    flex: 1,
    sortable: false,
  },
  {
    field: "userStatus",
    headerName: "Status",
    flex: 1,
    sortable: false,
  }
];

export const clientsColumns: GridColDef[] = [
  {
    field: "associate_account",
    headerName: "Firma",
    flex: 1,
  },
  {
    field: "name",
    headerName: "Name",
    flex: 1,
  },
  {
    field: "role_key",
    headerName: "Rolle",
    flex: 1,
    sortable: false,
    valueGetter: (params) => {
      return roleNameByKey[params.row.role_key] ?? params.row.role ?? "-";
    },
  },
  {
    field: "userStatus",
    headerName: "Status",
    flex: 1,
    sortable: false,
  }
];